module.exports = __webpack_public_path__ + "media/footer/facebook-dcad3e3e.svg";